import MultiplePlaylistsRenameModal from './MultiplePlaylistsRenameModal'

export default MultiplePlaylistsRenameModal
// eslint-disable-next-line import/export
export * from './MultiplePlaylistsRenameModal'
